/* tslint:disable */
/* eslint-disable */
/**
 * Flight Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AirportDto } from '../model';
// @ts-ignore
import { CityAirportResponse } from '../model';
// @ts-ignore
import { CountryResponseDto } from '../model';
// @ts-ignore
import { NearbyAirportsResponse } from '../model';
/**
 * AirportsApiApiAirportsCountriesGet - axios parameter creator
 * 
 * @summary Get Countries
 * @param {string} [searchTerm] کلمه ی قابل سرچ
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AirportsApiApiAirportsCountriesGetAxiosParamCreator (searchTerm?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Airports/Countries`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (searchTerm !== undefined) {
        localVarQueryParameter['searchTerm'] = searchTerm;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AirportsApiApiAirportsGet - axios parameter creator
 * 
 * @summary دریافت لیست فرودگاه ها
 * @param {string} [term] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AirportsApiApiAirportsGetAxiosParamCreator (term?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Airports`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (term !== undefined) {
        localVarQueryParameter['term'] = term;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AirportsApiApiAirportsGetAllGet - axios parameter creator
 * 
 * @summary دریافت لیست فرودگاه ها
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AirportsApiApiAirportsGetAllGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Airports/GetAll`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AirportsApiApiAirportsNearbyGet - axios parameter creator
 * 
 * @summary دریافت لیست فرودگاه های نزدیک به مسافر
 * @param {number} [originLatitude] 
 * @param {number} [destinationLatitude] 
 * @param {number} [originLongitude] 
 * @param {number} [destinationLongitude] 
 * @param {string} [departureDate] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AirportsApiApiAirportsNearbyGetAxiosParamCreator (originLatitude?: number, destinationLatitude?: number, originLongitude?: number, destinationLongitude?: number, departureDate?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Airports/Nearby`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (originLatitude !== undefined) {
        localVarQueryParameter['OriginLatitude'] = originLatitude;
    }

    if (destinationLatitude !== undefined) {
        localVarQueryParameter['DestinationLatitude'] = destinationLatitude;
    }

    if (originLongitude !== undefined) {
        localVarQueryParameter['OriginLongitude'] = originLongitude;
    }

    if (destinationLongitude !== undefined) {
        localVarQueryParameter['DestinationLongitude'] = destinationLongitude;
    }

    if (departureDate !== undefined) {
        localVarQueryParameter['DepartureDate'] = (departureDate as any instanceof Date) ?
            (departureDate as any).toISOString() :
            departureDate;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AirportsApiApiAirportsNearbyWithIpGet - axios parameter creator
 * 
 * @summary دریافت لیست فرودگاه های نزدیک  به مسافر از روی ای پی دستگاه مسافر
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AirportsApiApiAirportsNearbyWithIpGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Airports/NearbyWithIp`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAirportsCountriesGet operation in AirportsApi.
 * @export
 * @interface AirportsApiApiAirportsCountriesGetRequest
 */
export interface AirportsApiApiAirportsCountriesGetRequest {
    /**
     * کلمه ی قابل سرچ
     * @type {string}
     * @memberof AirportsApiApiAirportsCountriesGet
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for apiAirportsGet operation in AirportsApi.
 * @export
 * @interface AirportsApiApiAirportsGetRequest
 */
export interface AirportsApiApiAirportsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AirportsApiApiAirportsGet
     */
    readonly term?: string
}

/**
 * Request parameters for apiAirportsNearbyGet operation in AirportsApi.
 * @export
 * @interface AirportsApiApiAirportsNearbyGetRequest
 */
export interface AirportsApiApiAirportsNearbyGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AirportsApiApiAirportsNearbyGet
     */
    readonly originLatitude?: number

    /**
     * 
     * @type {number}
     * @memberof AirportsApiApiAirportsNearbyGet
     */
    readonly destinationLatitude?: number

    /**
     * 
     * @type {number}
     * @memberof AirportsApiApiAirportsNearbyGet
     */
    readonly originLongitude?: number

    /**
     * 
     * @type {number}
     * @memberof AirportsApiApiAirportsNearbyGet
     */
    readonly destinationLongitude?: number

    /**
     * 
     * @type {string}
     * @memberof AirportsApiApiAirportsNearbyGet
     */
    readonly departureDate?: string
}

/**
* 
* @summary Get Countries
* @param {AirportsApiApiAirportsCountriesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AirportsApiApiAirportsCountriesGet(requestParameters: AirportsApiApiAirportsCountriesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AirportsApiApiAirportsCountriesGetAxiosParamCreator(requestParameters.searchTerm, options, configuration);
    const request: () => AxiosPromise<Array<CountryResponseDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست فرودگاه ها
* @param {AirportsApiApiAirportsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AirportsApiApiAirportsGet(requestParameters: AirportsApiApiAirportsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AirportsApiApiAirportsGetAxiosParamCreator(requestParameters.term, options, configuration);
    const request: () => AxiosPromise<Array<CityAirportResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست فرودگاه ها
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AirportsApiApiAirportsGetAllGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AirportsApiApiAirportsGetAllGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<AirportDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست فرودگاه های نزدیک به مسافر
* @param {AirportsApiApiAirportsNearbyGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AirportsApiApiAirportsNearbyGet(requestParameters: AirportsApiApiAirportsNearbyGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AirportsApiApiAirportsNearbyGetAxiosParamCreator(requestParameters.originLatitude, requestParameters.destinationLatitude, requestParameters.originLongitude, requestParameters.destinationLongitude, requestParameters.departureDate, options, configuration);
    const request: () => AxiosPromise<Array<NearbyAirportsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت لیست فرودگاه های نزدیک  به مسافر از روی ای پی دستگاه مسافر
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AirportsApiApiAirportsNearbyWithIpGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AirportsApiApiAirportsNearbyWithIpGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<NearbyAirportsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
